import styled from '@mui/material/styles/styled';

const Span = styled('span')({});

export default Span;
